import { QueryKey, useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError, AxiosRequestConfig, AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

import { publicApi } from '@/utils/api';

interface AxiosResponse<T = any, D = any> {
  data: T;
  status: number;
  statusText: string;
  headers: RawAxiosResponseHeaders | AxiosResponseHeaders;
  config: AxiosRequestConfig<D>;
  request?: any;
}

interface UsePublicApiQueryOptions<ResponseType, ErrorType> extends Omit<
  UseQueryOptions<AxiosResponse<ResponseType>, AxiosError<ErrorType>, ResponseType>,
  'queryKey' | 'queryFn'
> {
  requestConfig?: Omit<AxiosRequestConfig, 'url'>;
}

const usePublicApiQuery = <ResponseType, ErrorType>(
  queryKey: QueryKey,
  url: string,
  options?: UsePublicApiQueryOptions<ResponseType, ErrorType>,
): UseQueryResult<ResponseType, AxiosError<ErrorType>> =>
  useQuery({
    queryKey,
    queryFn: () => publicApi.get(url, options?.requestConfig),
    select: (response) => response.data,
    ...options,
  });

export default usePublicApiQuery;
